import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  backgroundColor?: string;
  disabled?: boolean;
  bgHover?: string;
}

export const Root = styled.div`
  height: 100%;
  box-sizing: border-box;
  padding: 32px 27px 32px 27px;
`

export const BoxContainer = styled.div`
  width: 287px;
  min-height: 232px;
  max-height: 100%;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 0 rgba(0, 0, 0, 0.15);
  border: solid 1px #101059;
  display: flex;
  flex-direction: column;
`

export const Title = styled.div`
  padding: 30px 30px 16px 30px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.6px;
  color: ${C.DARK_BLUE};
`

export const FoldersContainer = styled.div`
  overflow-y: auto;
`
export const FolderDelete = styled.div`
  display: none;
  &:hover svg path {
    fill-opacity: 1;
  }
`;

export const FolderContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 9px 20px 9px 30px;
  cursor: pointer;
  width: 100%;
  &:hover ${FolderDelete} {
    display: block;
  }
`

export const FolderTitle = styled.div`
  padding: 0px 10px 0px 0px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.LIGHT_BLACK};
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  width: 100%;
`

export const ContainerInfo = styled.div`
  margin-left: auto;
  display: inline-flex;
`

export const FolderNumber = styled.div`
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.LIGHT_BLACK};
`

export const newFolderContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 30px 16px 30px;
  cursor: pointer;
  &:hover {
    background-color: rgba(32, 64, 120, 0.05);
  }
`

export const newFolderIconContainer = styled.div`
  transform: scale(0.9);
  padding: 0px 4px 0px 0px;
`

export const newFolderTitle = styled.div`
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(16, 16, 89, 0.6);
`